import * as d3 from 'd3'
import Vue from 'vue'
import axios from 'axios'
import Papa from 'papaparse';
import {_} from 'underscore'
var slugify = require("underscore.string/slugify")
var numberFormat = require('underscore.string/numberFormat')

var GLOBAL_REAL_ESTATE = 326500;

var TEXTS_SHEET_ID = 72299173;
var DOWNLOAD_SHEET_ID = 1112030159;

var DB_FINANCIAL = {};

var REAL_ESTATE_TOOLTIPS = {
    "Paris": {
        "title": "Paris (France)",
        "label": "Paris",
        "source": "Fichiers Fonciers; Property tax Returns;French National Registry of Corporations (RNE)",
        "type": "Administrative"
    },
    "London":{
        "title": "London (United Kingdom)",
        "label": "London",
        "source": "Overseas Companies Ownership Data (OCOD); Overseas Individuals Owning Properties in the UK",
        "type": "Administrative"
    },
    "Dubai":{
        "title": "Dubai (United Arab Emirates)",
        "label": "Dubai",
        "source": "Center for Advanced Defense Studies (C4ADS)",
        "type": "Leaked Data"
    },
    "Singapore":{
        "title": "Singapore",
        "label": "Singapore",
        "source": "National Statisiticak Agency; REALIS",
        "type": "Administrative"
    },
    "Oslo":{
        "title": "Oslo (Norway)",
        "label": "Oslo",
        "source": "Eiendomsverdi AS",
        "type": "Administrative"
    },
    "Côte d'Azur":{
        "title": "Côte d'Azur (France)",
        "label": "Côte d'Azur",
        "source": "Fichiers Fonciers; Property tax Returns;French National Registry of Corporations (RNE)",
        "type": "Administrative"
    }
}


var DATASETS_PARAMS = {
    "effective-tax":{
        id: "effective-tax",
        order: 4,
        sheetID: "1238919499",
        label: "Effective tax rates on capital and labor",
        datasetText: "Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression. Le Lorem Ipsum est le faux texte standard de l'imprimerie depuis les années 1500, quand un imprimeur anonyme assembla ensemble des morceaux de texte pour réaliser un livre spécimen de polices de texte.",
        mapTitle: "Do effective tax rates differ much worldwide?",
        mapMoreText: "This map shows the effective tax rates on either capital income, corporate profits, or labor income, or the total tax revenue as a share of national domestic product (NDP). Effective tax rates indicates the tax burden faced by a factor of production. They are constructed as ratios of tax revenues collected on a factor of production divided by the factor’s value in national accounts. The map covers 155 countries, including all countries with over 1 million inhabitants, for the period 1965-2020. Indirect tax revenue is excluded from the computation of effective tax rates on capital, corporate profits and labor.",
        timeseriesTitle: "How have effective tax rates vary evolved over time?",
        timeseriesMoreText: "Globally, since 1965, effective labor and capital tax rates have converged, with a substantial increase in the effective tax rate on labor income and a moderate decrease in the effective tax rate on capital income. The rise in labor taxation is a worldwide phenomenon. On the contrary, the global decline in capital taxation is concentrated in high-income countries, driven by the collapse of taxation on corporate profits. By contrast, capital taxation has increased in developing economies (especially large ones) since the 1990s, albeit starting from a low level. Today, effective tax rates on capital income are still lower in low- and middle-income countries than in high-income countries.",
        hasTaxHavenData: false,
        indicators: [
            { label: "Effective capital tax rate", id: "Capital_tax_rate", unit: "%", smallUnit: "%", computed: false, color: "#2E5BB0" },
            { label: "Effective corporate tax rate", id: "Corporate_tax_rate", unit: "%", smallUnit: "%", computed: false, color: "#47C1DC" },
            { label: "Effective labor tax rate", id: "Labor_tax_rate", unit: "%", smallUnit: "%", computed: false, color: "#E3555E" },
            { label: "Tax to NDP ratio", id: "Total_tax_NDP", unit: "%", smallUnit: "%", computed: false, color: "#BABEC9" },
        ]
    },
    "global-profit":{
        id: "global-profit",
        order: 1,
        sheetID: "686477796",
        label: "Global profit shifting by multinational enterprises",
        datasetText: "Profit shifting refers to the practice employed by multinational enterprises (MNEs) to shift profits from high-tax jurisdictions to low-tax or tax haven jurisdictions. The primary goal of profit shifting is to minimize the overall tax liability of the MNEs. Profit shifting involves various strategies, including: - moving intangible assets: Intangibles (e.g. patents) produced or managed in high-tax countries are moved to entities in tax havens. - Intra-group interest payments: entities in high-tax countries borrow money (at potentially high rates) from entities in tax havens. - Transfer mispricing: manipulation of intra group export and import prices to shift costs and revenues between entities.",
        mapTitle: "Where are the missing profits?",
        mapMoreText: "Profit shifting is a complex phenomenon whereby multinational enterprises shift their profits to tax havens to reduce their tax liabilities. Our research shows that about 36% of profits from MNEs – which accounted for close to $1 trillion in 2019 - are shifted each year to tax havens. This map shows which countries gain and which lose in this tax planning game by MNEs. Use the switch button above the map to change the focus from nontax havens to tax havens and explore which countries attract most profits in this game. Change the indicator to see how profit shifting translates into gains and losses in corporate tax revenues. Change regional and income level filters to narrow down the analysis to a specific set of countries and press the “play” button to view how the map evolves over time. Download our data to know more about our findings.",
        barchartTitle: "Which countries are most affected?",
        timeseriesTitle: "How profit shifting evolves over time?",
        timeseriesMoreText: "This chart shows the evolution of key profit shifting indicators over the years 2015-2020. Change the settings with the filters at the top of the page to obtain new perspectives of this phenomenon. Download our data to know more about our findings.",
        indicatorsText: "In this dataset, tax havens are defined as countries having excessive profitability of multinational firms and an effective corporate tax rate below 15 per cent",
        hasTaxHavenData: true,
        indicators:[
            { label: "Corporate tax revenue as a share of corporate tax revenue collected", id: "corp_tax_lost", taxHavenID: "corp_tax_gain", unit: "%", smallUnit: "%", computed: false, modalLabel: "of its corporate tax revenue because of profits shifted to the following tax havens:" },
            { label: "Profits", id:"profits_shifted", taxHavenID: "shifted_profits", unit: "USD billions", smallUnit: " B$", computed: false, modalLabel: "of its profits because of profits shifted to the following tax havens:" },
            { label: "Tax revenue", id: "tax_lost", taxHavenID: "tax_won", unit: "USD billions", smallUnit: " B$", computed: false, modalLabel: "of its tax revenue because of profits shifted to the following tax havens:" }
        ],
        counterparts: [
            { label: "World", id: "World" },
            { label: "EU Havens", id: "EU_Havens" },
            { label: "Non-EU Havens", id: "Non_EU_Havens" }
        ]
    },
    "offshore-financial":{
        id: "offshore-financial",
        order: 2,
        sheetID: "2097452214",
        label: "Offshore financial wealth",
        datasetText: "How much financial wealth is held offshore? Who owns it and where is it located? The offshore financial wealth dataset provides up-to-date estimates of the missing financial wealth of nations, its development over time, worldwide and by country. We derive our estimates from the fact that globally reported financial liabilities exceed reported assets. This is partly due to asset owners concealing their wealth from domestic authorities, for example by using shell companies located in tax havens.",
        mapTitle: "Who owns offshore financial wealth?",
        mapMoreText: "This map shows the offshore financial wealth held in each country. The map covers XX countries, for the period 2001-2022. Dark-shaded countries own (or host) more offshore financial wealth than light-shaded countries.",
        barchartTitle: "Which countries own most offshore financial wealth?",
        timeseriesTitle: "How profit shifting evolves over time?",
        areaChartTitle: "How has offshore financial wealth evolved over time?",
        areaMoreText: "Global offshore financial wealth has increased in absolute and in relative terms since 2001. The graph discloses a breakdown by tax haven group, namely American, European, and Asian havens, and Switzerland. The share of Switzerland, one of the major providers of offshore financial wealth management, has declined over the last decades.",
        hasTaxHavenData: true,
        indicators: [
            { label: "Percent of GDP", subtitleLabel:"Offshore financial wealth", homeLabel: "Offshore financial wealth", id: "pctGDPFinancial", unit: "%", homeUnit: "% of GDP", smallUnit: "%", computed: true, computationParams: { numerator: "total", numeratorTaxHaven: "total_attracted", denominator: "gdp_USD_billion"}, modalLabel: "of its GDP in tax havens:", modalLabelTaxHaven: "of its GDP" },
            { label: "Total", subtitleLabel:"Total offshore financial wealth", id: "total", taxHavenID: "total_attracted", unit: "USD billions", smallUnit: " B$", computed: false, modalLabel: "in tax havens:", modalLabelTaxHaven: "" },
            /*{ label: "Share of total personal wealth", id: "pctHouseholdWealth", unit: "%", smallUnit: "%", computed: true, computationParams: { numerator: "total", numeratorTaxHaven: "total_attracted" , denominator: "personal_wealth_USD_billion" } },*/
            //{ label: "% of total offshore financial wealth", id: "pctOffshoreWealth", unit: "%", computed: true, computationParams: { numerator: "total", numeratorTaxHaven: "total_attracted", denominator: "custom" } },
        ]
    },
    "offshore-real-estate": {
        id: "offshore-real-estate",
        order: 3,
        sheetID: "33936108",
        label: "Offshore real estate wealth",
        datasetText: "Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression. Le Lorem Ipsum est le faux texte standard de l'imprimerie depuis les années 1500, quand un imprimeur anonyme assembla ensemble des morceaux de texte pour réaliser un livre spécimen de polices de texte.",
        mapTitle: "Where to find owners of offshore real estate?",
        mapMoreText: "This map shows the offshore real estate in important cities. Offshore real estate is real estate that is either ultimately owned by an investor in a different country or is owned through complex offshore structures that can obfuscate the identity of the real owner. The map outlines the offshore real estate wealth owned by the residents of each country in the world for a set of important cities. The baseline values are reported in USD billions. The values are also scaled by GDP (retrieved from the World Bank, current in 2020 or last year available) if the indicator is \"% of GDP\". The values are shown as the percentage of the total offshore real in the city if the indicator is \"% of city's total real estate\". The values are shown as the percentage of all real estate in the world if the indicator is \"% of global real estate\".",
        bubblesBarchartMoreText: "Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression. Le Lorem Ipsum est le faux texte standard de l'imprimerie depuis les années 1500, quand un imprimeur anonyme assembla ensemble des morceaux de texte pour réaliser un livre spécimen de polices de texte… ition et la mise en page avant impression. Le Lorem Ipsum est le faux texte standard de l'imprimerie depuis les années 1500, quand un imprimeu",
        barchartTitle: "How does the ranking look like?",
        timeseriesTitle: "How profit shifting evolves over time?",
        hasTaxHavenData: false,
        indicators: [
            { label: "Offshore real estate owned in London, Paris, Côte d'Azur, Dubai, Singapore, and Oslo as a share of GDP", id:"pctGDP", computed: true, unit: "%", smallUnit: "%", computationParams: { numerator: "Aggregate (in USD billions)", denominator: "gdp_USD_billion" } },
            { label: "Total offshore real estate owned in London, Paris, Côte d'Azur, Dubai, Singapore, and Oslo", id: "Aggregate (in USD billions)", unit: "USD billions", smallUnit: " B$", computed: false },
            //{ label: "% of city's total real estate", id:"pctCityEstate", computed: true, unit: "%", computationParams: { numerator: "sum", denominator: "custom" } },
            { label: "Share of total offshore real estate in city", id:"pctGlobalEstate", computed: true, unit: "%", smallUnit: "%", isOnlyCountry: true, computationParams: { numerator: "Aggregate (in USD billions)", denominator: "custom" } },
        ]
    }
}

var INDICATORS_PARAMS = {
    "Profits_shifted": { id: "profits_shifted", label: "Profits shifted" },
    "corp_tax_lost": { id: "corp_tax_lost", label: "Corp. tax lost" },
    "tax_lost": { id: "tax_lost", label: "Tax lost" },
    "Capital_tax_rate": { id: "Capital_tax_rate", label: "Capital tax rate", color: "#2E5BB0"},
    "Corporate_tax_rate": { id: "Corporate_tax_rate", label: "Corporate tax rate", color: "#47C1DC"},
    "Labor_tax_rate": { id: "Labor_tax_rate", label: "Labor tax rate", color: "#E3555E"},
    "Total_tax_NDP": { id: "Total_tax_NDP", label: "Total tax NDP", color: "#BABEC9"},
    "americ": {id: "americ", label: "American tax havens", color: "#57B948"},
    "europe": {id: "europe", label: "European tax havens", color: "#204FAA"},
    "asian": {id: "asian", label: "Asian tax havens", color: "#BF84CD"},
    "swiss": {id: "swiss", label: "Switzerland", color: "#5BAB93"},
};

var UNITS_PARAMS = {
    "million_USD": { id: "million_USD", label: "M$" },
    "percentage_of_corp_tax_rev": { id: "percentage_of_corp_tax_rev", label: "%" },
}

var DB_REGIONS = [
    { label: "World", id: "World" },
    { label: "Europe and Central Asia", id: "Europe and Central Asia" },
    { label: "Middle East and North Africa", id: "Middle East and North Africa" },
    { label: "South Asia", id: "South Asia" },
    { label: "Latin America and Caribbean", id: "Latin America and Caribbean" },
    { label: "Sub-Saharan Africa", id: "Sub-Saharan Africa" },
    { label: "East Asia and Pacific", id: "East Asia and Pacific" },
    { label: "North America", id: "North America" },
]
var ALL_REGION_ID = "World";

var FINANCIAL_REGIONS = {
    "americ": {id: "americ", label: "American tax havens", color: "#29264C"},
    "europe": {id: "europe", label: "European tax havens", color: "#204FAA"},
    "asian": {id: "asian", label: "Asian tax havens", color: "#6180BC"},
    "swiss": {id: "swiss", label: "Switzerland", color: "#BAC6DF"},
}

var DB_INCOME_LEVELS = [
    { label: "All income levels", id: "All income levels" },
    { label: "High income", id: "High income" },
    { label: "Low income", id: "Low income" },
    { label: "Upper middle income", id: "Upper middle income" },
    { label: "Lower middle income", id: "Lower middle income" },
]
var ALL_INCOME_LEVEL_ID = "All income levels";

var DB_COUNTRIES_OBJ = {};
var DB_COUNTRIES_DENOMINATOR_OBJ = {};
var DB_REALESTATE_CITIES = {};


function loadDatasetsCSVData() {
  return Promise.all([
    d3.csv("/data/dataset-effective-tax.csv"),
    d3.csv("/data/dataset-global-profit.csv"),
    d3.csv("/data/dataset-offshore-financial-new.csv"),
    d3.csv("/data/dataset-offshore-real-estate.csv"),
  ]).then(filesData => {
        var DBDatasets = createDatasets(filesData);
        return Promise.all([
            d3.csv("/data/dataset-global-profit-tooltip.csv")
        ]).then(filesData => {
            DBDatasets = loadProfitShiftingTooltipData(filesData, DBDatasets);
            return DBDatasets;
        }).catch(err => {
            console.log(err);
          });
        
      }).catch(err => {
        console.log(err);
      });
}

function loadEffectiveTaxModalCSVData(){
    return Promise.all([
    d3.csv("/data/effective-tax-country-average.csv"),
    d3.csv("/data/effective-tax-income-average.csv"),
    d3.csv("/data/effective-tax-region-average.csv"),
    d3.csv("/data/effective-tax-share-revenue.csv")
  ]).then(filesData => {
        var DBEffectiveTax = createDBEffectiveTax(filesData);
        return DBEffectiveTax;
      }).catch(err => {
        console.log(err);
      });
}

function loadProfitShiftingModalCSVData(){
    return Promise.all([
    d3.csv("/data/dataset-global-profit-taxhaven-tooltip.csv"),
  ]).then(filesData => {
        var DBGlobalProfitTaxhavenTooltip = createDBGlobalProfitTaxhavenTooltip(filesData);
        return DBGlobalProfitTaxhavenTooltip;
      }).catch(err => {
        console.log(err);
      });
}

function loadDatasetsSpreadsheetData() {
    const sheetIds = ['1238919499', '686477796', '2097452214', '33936108']; // replace with your actual sheet IDs
    //https://docs.google.com/spreadsheets/d/e/2PACX-1vTt1SHBywkgzbVHR-bcUeEQBkTTIZ_bgeTQJDVtooZJioS3edNxhY_5__NfnUv025WwAWH78nATg9V-/pubhtml
    const spreadsheetId = '2PACX-1vTt1SHBywkgzbVHR-bcUeEQBkTTIZ_bgeTQJDVtooZJioS3edNxhY_5__NfnUv025WwAWH78nATg9V-'; // replace with your actual spreadsheet ID
    let promises = sheetIds.map(sheetId => loadSpreadsheetData(spreadsheetId, sheetId));

    return Promise.all(promises)
      .then(spreadsheetsData => {
        var DBDatasets = createDatasets(spreadsheetsData);
        return DBDatasets;
      })
      .catch(error => console.error('Error loading data:', error));
}

async function loadSpreadsheetData(spreadsheetId, sheetId, format = 'csv') {
    const url = `https://docs.google.com/spreadsheets/d/e/${spreadsheetId}/pub?gid=${sheetId}&single=true&output=${format}&rand=123`;
    try {
        const response = await fetch(url);
        const data = await response.text();

        return new Promise((resolve, reject) => {
          Papa.parse(data, {
            header: true,
            complete: results => resolve(results.data),
            error: error => reject(error)
          });
        });
    } catch (error) {
        console.error("Error loading data:", error);
    }


    const response = await fetch(url);
    const data = await response.text();
    return data;
}

function loadSingleDatasetsCSVData(datasetID){
    return Promise.all([
        d3.csv("/data/dataset-"+datasetID+".csv")
    ]).then(filesData => {
        var DBDatasets = createDatasets(filesData, datasetID);

        if(datasetID == "global-profit"){
            return Promise.all([
            d3.csv("/data/dataset-global-profit-tooltip.csv")
            ]).then(filesData => {
                DBDatasets = loadProfitShiftingTooltipData(filesData, DBDatasets);
                return DBDatasets;
            }).catch(err => {
                console.log(err);
              });
        } else {
            return DBDatasets;
        }

        
    })
}

function loadSingleDatasetsSpreadsheetData(datasetID){
    var sheetID = DATASETS_PARAMS[datasetID].sheetID;
    var sheetIds = [sheetID];

    const spreadsheetId = '2PACX-1vTt1SHBywkgzbVHR-bcUeEQBkTTIZ_bgeTQJDVtooZJioS3edNxhY_5__NfnUv025WwAWH78nATg9V-'; // replace with your actual spreadsheet ID
    let promises = sheetIds.map(sheetId => loadSpreadsheetData(spreadsheetId, sheetId));

    return Promise.all(promises)
      .then(spreadsheetsData => {
        var DBDatasets = createDatasets(spreadsheetsData, datasetID);
        return DBDatasets;
      })
      .catch(error => console.error('Error loading data:', error));
}

function loadTextsSpreadsheetData(){
    var sheetID = TEXTS_SHEET_ID;
    var sheetIds = [sheetID];

    const spreadsheetId = '2PACX-1vTt1SHBywkgzbVHR-bcUeEQBkTTIZ_bgeTQJDVtooZJioS3edNxhY_5__NfnUv025WwAWH78nATg9V-'; // replace with your actual spreadsheet ID
    let promises = sheetIds.map(sheetId => loadSpreadsheetData(spreadsheetId, sheetId));

    return Promise.all(promises)
      .then(spreadsheetsData => {
        return spreadsheetsData[0];
      })
      .catch(error => console.error('Error loading data:', error));
}

function loadTextsCSVData(){
    return Promise.all([
        d3.csv("/data/pages-texts.csv")
    ]).then(filesData => {
        return filesData[0]
    })
}

function loadDownloadSpreadsheetData(){
    var sheetID = DOWNLOAD_SHEET_ID;
    var sheetIds = [sheetID];

    const spreadsheetId = '2PACX-1vTt1SHBywkgzbVHR-bcUeEQBkTTIZ_bgeTQJDVtooZJioS3edNxhY_5__NfnUv025WwAWH78nATg9V-'; // replace with your actual spreadsheet ID
    let promises = sheetIds.map(sheetId => loadSpreadsheetData(spreadsheetId, sheetId));

    return Promise.all(promises)
      .then(spreadsheetsData => {
        return spreadsheetsData[0];
      })
      .catch(error => console.error('Error loading data:', error));
}

function loadDownloadCSVData(){
    return Promise.all([
        d3.csv("/data/downloads.csv")
    ]).then(filesData => {
        console.log("filesData", filesData);
        return filesData[0]
    })
}

function loadRealEstate2SpreadsheetData(){
    var sheetID = '1245285697';
    var sheetIds = [sheetID];

    const spreadsheetId = '2PACX-1vTt1SHBywkgzbVHR-bcUeEQBkTTIZ_bgeTQJDVtooZJioS3edNxhY_5__NfnUv025WwAWH78nATg9V-'; // replace with your actual spreadsheet ID
    let promises = sheetIds.map(sheetId => loadSpreadsheetData(spreadsheetId, sheetId));

    return Promise.all(promises)
      .then(spreadsheetsData => {
        return spreadsheetsData[0];
      })
      .catch(error => console.error('Error loading data:', error));
}

function loadRealEstate2CSVData(){
    return Promise.all([
        d3.csv("/data/dataset-offshore-real-estate2.csv")
    ]).then(filesData => {
        return filesData[0]
    })
}

function loadStaticSpreadsheetData(){
    const sheetIds = ['661775164', '1032944151']; 
    const spreadsheetId = '2PACX-1vTt1SHBywkgzbVHR-bcUeEQBkTTIZ_bgeTQJDVtooZJioS3edNxhY_5__NfnUv025WwAWH78nATg9V-'; // replace with your actual spreadsheet ID
    let promises = sheetIds.map(sheetId => loadSpreadsheetData(spreadsheetId, sheetId));

    return Promise.all(promises)
      .then(spreadsheetsData => {
        return spreadsheetsData;
      })
      .catch(error => console.error('Error loading data:', error));
}

function loadStaticCSVData(){
    return Promise.all([
        d3.csv("/data/news.csv"),
        d3.csv("/data/research-briefs.csv")
    ]).then(filesData => {
        return filesData
    })
}

function createDBGlobalProfitTaxhavenTooltip(filesData){
    console.log("createDBGlobalProfitTaxhavenTooltip", filesData);

    var DBGlobalProfitTaxhavenTooltip = {};

    _.each(filesData[0], function (rowData){
        console.log("rowData", rowData)
        if(DBGlobalProfitTaxhavenTooltip[rowData["ISO3"]] == undefined){
            DBGlobalProfitTaxhavenTooltip[rowData["ISO3"]] = {
                years: {}
            }
        }

        DBGlobalProfitTaxhavenTooltip[rowData["ISO3"]].years[rowData["year"]] = {
            corptaxrev: parseFloat(rowData["corptaxrev"]),
            corporateETR: parseFloat(rowData["corporate_ETR"])*100
        }
    });

    console.log("DBGlobalProfitTaxhavenTooltip", DBGlobalProfitTaxhavenTooltip)

    return DBGlobalProfitTaxhavenTooltip;
}

function createDBEffectiveTax(filesData){
    console.log("createDBEffectiveTax", filesData);

    var DBEffectiveTax = {
        "country-average":{},
        "income-average": {},
        "region-average": {},
        "share-revenue": {}
    };
    var datasetsKeys = [];
    datasetsKeys = _.keys(DBEffectiveTax);

    for(let i = 0; i < datasetsKeys.length; i++) {
        let datasetID = datasetsKeys[i];
        let data = filesData[i];

        data.forEach(row => {

            if(datasetID == "country-average"){
                DBEffectiveTax["country-average"][row.iso3] = {
                    countryID: row.iso3,
                    "Capital_tax_country_average": parseFloat(row["Capital_tax_country_average"]),
                    "Labor_tax_country_average": parseFloat(row["Labor_tax_country_average"]),
                    "Corporate_tax_country_average": parseFloat(row["Corporate_tax_country_average"]),
                    "Total_tax_country_average": parseFloat(row["Total_tax_country_average"]),
                }
            } else if(datasetID == "income-average"){
                if(!DBEffectiveTax["income-average"][row.incomelevelname]){
                    DBEffectiveTax["income-average"][row.incomelevelname] = {
                        label: row.incomelevelname,
                        years: {}
                    }
                }
                DBEffectiveTax["income-average"][row.incomelevelname].years[row.year] = {
                    "Capital_tax_income_average": parseFloat(row["Capital_tax_income_average"]),
                    "Labor_tax_income_average": parseFloat(row["Labor_tax_income_average"]),
                    "Corporate_tax_income_average": parseFloat(row["Labor_tax_income_average"]),
                    "Total_tax_income_average": parseFloat(row["Total_tax_income_average"])
                }
            } else if(datasetID == "region-average"){
                if(!DBEffectiveTax["region-average"][row.regionname]){
                    DBEffectiveTax["region-average"][row.regionname] = {
                        label: row.regionname,
                        years: {}
                    }
                }
                DBEffectiveTax["region-average"][row.regionname].years[row.year] = {
                    "Capital_tax_region_average": parseFloat(row["Capital_tax_region_average"]),
                    "Labor_tax_region_average": parseFloat(row["Labor_tax_region_average"]),
                    "Corporate_tax_region_average": parseFloat(row["Corporate_tax_region_average"]),
                    "Total_tax_region_average": parseFloat(row["Total_tax_region_average"])
                }
            } else if(datasetID == "share-revenue"){
                 if(!DBEffectiveTax["share-revenue"][row.iso3]){
                    DBEffectiveTax["share-revenue"][row.iso3] = {
                        iso3: row.iso3,
                        years: {}
                    }
                }
                DBEffectiveTax["share-revenue"][row.iso3].years[row.year] = {
                    "Share_personal_tax_individual": parseFloat(row["Share_personal_tax_individual"]),
                    "Share_personal_tax_corporate": parseFloat(row["Share_personal_tax_corporate"]),
                    "Share_payroll_tax": parseFloat(row["Share_payroll_tax"]),
                    "Share_property_tax": parseFloat(row["Share_property_tax"]),
                    "Share_indirect_tax": parseFloat(row["Share_indirect_tax"]),
                    "Share_other_tax": parseFloat(row["Share_other_tax"]),
                }
            }
            
        })
    }

    return DBEffectiveTax;
}

function createDatasets(filesData, datasetID) {

    var DBDatasets = {};
    var datasetsKeys = [];

    if(filesData.length > 1) {
        var DBDatasets = {
            "effective-tax": {},
            "global-profit": {},
            "offshore-financial": {},
            "offshore-real-estate": {},
        };
        datasetsKeys = _.keys(DBDatasets);
    } else {
        DBDatasets[datasetID] = {};
        datasetsKeys = [datasetID];
    }

    DB_REALESTATE_CITIES = {};

    for(let i = 0; i < datasetsKeys.length; i++) {
      let datasetID = datasetsKeys[i];
      let data = filesData[i];

      data.forEach(row => {
        if(row.iso3 != ""){

            if(!DBDatasets[datasetID][row.iso3]) {
              DBDatasets[datasetID][row.iso3] = {
                indicators: {}
              };
            }

            if(!DBDatasets[datasetID][row.iso3].indicators[row.indicator]) {
                
                if(datasetID == "effective-tax"){
                    DBDatasets[datasetID][row.iso3].indicators[row.indicator] = {
                        years: {}
                    };
                } else if(datasetID == "global-profit") {
                    DBDatasets[datasetID][row.iso3].indicators[row.indicator] = {};
                    DBDatasets[datasetID][row.iso3].indicators[row.indicator].unit = row.unit;
                    DBDatasets[datasetID][row.iso3].indicators[row.indicator].counterparts = {};
                    DBDatasets[datasetID][row.iso3].indicators[row.indicator].extended = [];
                } else if(datasetID == "offshore-financial" || datasetID == "offshore-real-estate"){
                    DBDatasets[datasetID][row.iso3].indicators[row.indicator] = {
                        years: {}
                    };
                    DBDatasets[datasetID][row.iso3].indicators[row.indicator].unit = row.unit;
                }
            }

            if(datasetID == "global-profit") {
                var extendedValue = "";
                
                if(!DBDatasets[datasetID][row.iso3].indicators[row.indicator].counterparts[row.counterpart]){
                    DBDatasets[datasetID][row.iso3].indicators[row.indicator].counterparts[row.counterpart] = {
                        years: {}
                    }
                }

                if(row.indicator == "corp_tax_lost" || row.indicator == "corp_tax_gain"){
                    DBDatasets[datasetID][row.iso3].indicators[row.indicator].counterparts[row.counterpart].years[row.year] = { 
                        value: (row.value != '') ? parseFloat(row.value.replace(",",".")) * 100 : 'nodata'
                    };
                   // extendedValue = parseFloat(row.value2.replace(",",".")) * 100;
                } else {
                     DBDatasets[datasetID][row.iso3].indicators[row.indicator].counterparts[row.counterpart].years[row.year] = { 
                        value: (row.value != '') ? parseFloat(row.value.replace(",",".")) : 'nodata'
                    };
                    //extendedValue = parseFloat(row.value2.replace(",","."));
                }

                /*
                DBDatasets[datasetID][row.iso3].indicators[row.indicator].extended.push({
                    counterpart: row.counterpart,
                    year: row.year,
                    counterpartExtended: row.counterpart_extended,
                    value: extendedValue
                })
                */
               
            } else {
                if(datasetID == "offshore-real-estate") {
                    if(DB_REALESTATE_CITIES[row.city_label] == undefined){
                        DB_REALESTATE_CITIES[row.city_label] = {
                            city: row.city_label,
                            total: 0
                        };
                    }
                    if(DBDatasets[datasetID][row.iso3].indicators[row.indicator].years["2019"] == undefined){
                        DBDatasets[datasetID][row.iso3].indicators[row.indicator].years["2019"] = {}
                    }
                    DBDatasets[datasetID][row.iso3].indicators[row.indicator].years["2019"][row.city_label] = { 
                        value: (row.value != '') ? parseFloat(row.value.replace(",",".")) : 'nodata'
                    };

                    if(row.value != ''){
                        DB_REALESTATE_CITIES[row.city_label].total += parseFloat(row.value.replace(",","."));
                    }
                } else {
                    if(row.indicator == "Capital_tax_rate" || row.indicator == "Labor_tax_rate" || row.indicator == "Corporate_tax_rate" || row.indicator == "Total_tax_NDP"){
                        DBDatasets[datasetID][row.iso3].indicators[row.indicator].years[row.year] = { 
                            value: (row.value != '') ? parseFloat(row.value.replace(",",".")) * 100 : 'nodata'
                        };
                    } else {
                        DBDatasets[datasetID][row.iso3].indicators[row.indicator].years[row.year] = { 
                            value: (row.value != '') ? parseFloat(row.value.replace(",",".")) : 'nodata'
                        };

                        if(row.value_reported != undefined){
                            var valueReported = "nodata";
                            if(row.value_reported != '') valueReported = parseFloat(row.value_reported.replace(",",".")) 
                            DBDatasets[datasetID][row.iso3].indicators[row.indicator].years[row.year].value_reported = valueReported;
                        }
                    }
                    
                }
            }
        }
        
      });
    }

    DB_FINANCIAL = DBDatasets["offshore-financial"];

    return DBDatasets;
}

function loadProfitShiftingTooltipData(filesData, DBDatasets){
    console.log("DBDatasets", DBDatasets);
    console.log("loadProfitShiftingTooltipData", filesData);

    _.each(filesData[0], function (row){
        var extendedValue = "";

        if(row.indicator == "corp_tax_lost" || row.indicator == "corp_tax_gain"){
            extendedValue = parseFloat(row.value.replace(",",".")) * 100;
        } else {
            extendedValue = parseFloat(row.value.replace(",","."));
        }

        var staticCounterpart = "EU_Havens";
        if(row.counterpart == "Rest" || row.counterpart == "Non_EU_Havens") staticCounterpart = "Non_EU_Havens";
        else if(row.counterpart == "World") staticCounterpart = "World";

        DBDatasets["global-profit"][row.iso3].indicators[row.indicator].extended.push({
            counterpart: staticCounterpart,
            year: row.year,
            counterpartExtended: row.counterpart,
            value: extendedValue
        })

    })

    return DBDatasets;
}

function loadCountriesCSVData(){

    DB_COUNTRIES_OBJ = {};
    DB_COUNTRIES_DENOMINATOR_OBJ = {};

    return Promise.all([
        d3.csv("/data/country-metadata.csv"),
        d3.csv("/data/country-denominator.csv"),
    ]).then(filesData => {
        var DBCountries = [];
        var DBCountriesDenominator = [];

        DBCountries = filesData[0];
        _.each(DBCountries, function (cObj){

            switch(cObj.regionname){
                case "Europe and Central Asia": 
                    cObj.taxHavenGroup = "europe"; break;
                case "Latin America and Caribbean": 
                case "North America":
                    cObj.taxHavenGroup = "americ"; break;
                case "Sub-Saharan Africa": 
                    cObj.taxHavenGroup = "afric"; break;
                case "East Asia and Pacific":
                case "Middle East and North Africa":
                    cObj.taxHavenGroup = "asian"; break;
                default:
                    cObj.taxHavenGroup = "";
            }

            DB_COUNTRIES_OBJ[cObj.iso3] = cObj;


        })

        DBCountriesDenominator = filesData[1];
        _.each(DBCountriesDenominator, function (countryDenominatorObj){
            if(countryDenominatorObj.gdp_USD_billion != '') countryDenominatorObj.gdp_USD_billion = parseFloat(countryDenominatorObj.gdp_USD_billion);
            else countryDenominatorObj.gdp_USD_billion = 'nodata';

            if(countryDenominatorObj.personal_wealth_USD_billion != '') countryDenominatorObj.personal_wealth_USD_billion = parseFloat(countryDenominatorObj.personal_wealth_USD_billion);
            else countryDenominatorObj.personal_wealth_USD_billion = 'nodata';

            if(countryDenominatorObj.ndp_USD_billion != '') countryDenominatorObj.ndp_USD_billion = parseFloat(countryDenominatorObj.ndp_USD_billion);
            else countryDenominatorObj.ndp_USD_billion = 'nodata';

            if(countryDenominatorObj.cit_revenue_USD_billion != '') countryDenominatorObj.cit_revenue_USD_billion = parseFloat(countryDenominatorObj.cit_revenue_USD_billion);
            else countryDenominatorObj.cit_revenue_USD_billion = 'nodata';
            
        })

         _.each(DBCountriesDenominator, function (obj){
            if(DB_COUNTRIES_DENOMINATOR_OBJ[obj.iso3] == undefined){
                DB_COUNTRIES_DENOMINATOR_OBJ[obj.iso3] = {
                    code: obj.iso3,
                    years: {}
                }
            }

            if(DB_COUNTRIES_DENOMINATOR_OBJ[obj.iso3].years[obj.year] == undefined){
                DB_COUNTRIES_DENOMINATOR_OBJ[obj.iso3].years[obj.year] = {
                    gdp_USD_billion: obj.gdp_USD_billion,
                    personal_wealth_USD_billion: obj.personal_wealth_USD_billion,
                    ndp_USD_billion: obj.ndp_USD_billion,
                    cit_revenue_USD_billion: obj.cit_revenue_USD_billion
                }
            }
        })

        return {
            dbCountries: DBCountries,
            dbCountriesDenominator: DBCountriesDenominator
        }
    }).catch(err => {
        console.log(err);
    });
}

function loadCountriesSpreadsheetData(needsDenominator){
    var sheetIds = ['1220458032']; // replace with your actual sheet IDs
    if(needsDenominator) sheetIds = ['1220458032', '1501451745'];
    //https://docs.google.com/spreadsheets/d/e/2PACX-1vTt1SHBywkgzbVHR-bcUeEQBkTTIZ_bgeTQJDVtooZJioS3edNxhY_5__NfnUv025WwAWH78nATg9V-/pubhtml
    const spreadsheetId = '2PACX-1vTt1SHBywkgzbVHR-bcUeEQBkTTIZ_bgeTQJDVtooZJioS3edNxhY_5__NfnUv025WwAWH78nATg9V-'; // replace with your actual spreadsheet ID
    let promises = sheetIds.map(sheetId => loadCountrySpreadsheetData(spreadsheetId, sheetId));
    DB_COUNTRIES_OBJ = {};
    DB_COUNTRIES_DENOMINATOR_OBJ = {};

    return Promise.all(promises)
      .then(spreadsheetsData => {
        var DBCountries = [];
        var DBCountriesDenominator = [];


        DBCountries = spreadsheetsData[0];
        _.each(DBCountries, function (cObj){
            DB_COUNTRIES_OBJ[cObj.iso3] = cObj;
        })

        if(spreadsheetsData[1] !== undefined) {
            DBCountriesDenominator = spreadsheetsData[1];
            _.each(DBCountriesDenominator, function (countryDenominatorObj){
                if(countryDenominatorObj.gdp_USD_billion != '') countryDenominatorObj.gdp_USD_billion = parseFloat(countryDenominatorObj.gdp_USD_billion);
                else countryDenominatorObj.gdp_USD_billion = 'nodata';

                if(countryDenominatorObj.personal_wealth_USD_billion != '') countryDenominatorObj.personal_wealth_USD_billion = parseFloat(countryDenominatorObj.personal_wealth_USD_billion);
                else countryDenominatorObj.personal_wealth_USD_billion = 'nodata';

                if(countryDenominatorObj.ndp_USD_billion != '') countryDenominatorObj.ndp_USD_billion = parseFloat(countryDenominatorObj.ndp_USD_billion);
                else countryDenominatorObj.ndp_USD_billion = 'nodata';

                if(countryDenominatorObj.cit_revenue_USD_billion != '') countryDenominatorObj.cit_revenue_USD_billion = parseFloat(countryDenominatorObj.cit_revenue_USD_billion);
                else countryDenominatorObj.cit_revenue_USD_billion = 'nodata';
                
            })

             _.each(DBCountriesDenominator, function (obj){
                if(DB_COUNTRIES_DENOMINATOR_OBJ[obj.iso3] == undefined){
                    DB_COUNTRIES_DENOMINATOR_OBJ[obj.iso3] = {
                        code: obj.iso3,
                        years: {}
                    }
                }

                if(DB_COUNTRIES_DENOMINATOR_OBJ[obj.iso3].years[obj.year] == undefined){
                    DB_COUNTRIES_DENOMINATOR_OBJ[obj.iso3].years[obj.year] = {
                        gdp_USD_billion: obj.gdp_USD_billion,
                        personal_wealth_USD_billion: obj.personal_wealth_USD_billion,
                        ndp_USD_billion: obj.ndp_USD_billion,
                        cit_revenue_USD_billion: obj.cit_revenue_USD_billion
                    }
                }
            })
        }

        return {
            dbCountries: DBCountries,
            dbCountriesDenominator: DBCountriesDenominator
        }
      })
      .catch(error => console.error('Error loading data:', error));
}

async function loadCountrySpreadsheetData(spreadsheetId, sheetId, format = 'csv') {
    const url = `https://docs.google.com/spreadsheets/d/e/${spreadsheetId}/pub?gid=${sheetId}&single=true&output=${format}&rand=123`;
    try {
        const response = await fetch(url);
        const data = await response.text();

        return new Promise((resolve, reject) => {
          Papa.parse(data, {
            header: true,
            complete: results => resolve(results.data),
            error: error => reject(error)
          });
        });
    } catch (error) {
        console.error("Error loading data:", error);
    }


    const response = await fetch(url);
    const data = await response.text();
    return data;
}

function computeYearsMaxValue(rankingData) {
    var maxValue = 0;
    _.each(rankingData, function (rankingObj){
        if(rankingObj.years !== undefined){
             _.each(rankingObj.years, function (yearObj){
                if(yearObj.value > maxValue){
                    maxValue = yearObj.value;
                }
            })
        }
       
    })
    return maxValue;
}

function computeYearMaxValue(rankingData, yearID){
    var maxValue = 0;
    _.each(rankingData, function (rankingObj){
        if(rankingObj.years !== undefined){
            if(rankingObj.years[yearID] !== undefined && rankingObj.years[yearID].value > maxValue){
                maxValue = rankingObj.years[yearID].value;
            }
        }
    })
    return maxValue;
}

function isScientific(n) {
    return /^[\d.]+e-?\d+$/i.test(n.toString());
}

function formatNumber(num, significantDigits, unit){
    if(isScientific(num)) num = num.toFixed(20);
    var strNum = String(num);
    var isFloat = false;

    if(strNum.split(".").length > 0) isFloat = true;
    if(num < 1 && isFloat) return formatFloatToSignificantDigits(num, significantDigits);

    if(unit == "%") return numberFormat(num, 1, '', ',');
    return numberFormat(num, 0, '', ',');
}

function  formatFloatToSignificantDigits(num, significantDigits) {
    var strNum = String(num);

    var newStrNum = "";
    var incSignificant = 0;
    for (let char of strNum) {
        if(incSignificant >= significantDigits) break;
        if(char == "0" || char == "."){
            newStrNum += char;
        } else{
            incSignificant += 1;
            newStrNum += char;
        } 
    }

    return newStrNum;
}


// Export PDF call using Wedodata pdf tool exporter
function exportGTAB(containerID, exportParams) {
    this.dlElement = document.querySelector('#' + containerID);

    var isMap = "";
    var layout = "landscape";
    if(exportParams.isMap != undefined && exportParams.isMap){
        isMap = "ismap";
        layout = "portrait";
    }
    var HTMLOuter = this.dlElement.outerHTML;
    var datasHTML = "<html><head></head><body id='bodySite' size='A4' layout='"+layout+"'><div class='export_page "+isMap+"'><div class='export_header'><div class='header_image'></div><div class='header_title'>"+exportParams.title+"</div></div><div class='export_content'><div class='main'><div class='main_inner'>";
    datasHTML += HTMLOuter+"</div></div></div><div class='export_footer'><div class='footer_line'>"+location.href+"</div><div class='footer_line'>Exported on "+getCurrentDate()+"</div></div></div></body></html>";

    let apiUrl = 'https://staging-api.lestrafiquants.tools/v1/pdf/pse/html-to-pdf';
    let accessToken = "U2FsdGVkX1/YMu7RFsX1EWGByky7p5uDLrRIIIh8nw8KtwwnDHZJivfQlKR1AmleS2TE+Yb3wFay1RqDXEa+tiLK2a6rZr7+DwJneZoV5Ho6DR6RimD6Jo2dRFKVAECgcFJv8XRRRrtdleqjOth8NIFgDkQCbtnSKBfSumJcGwjogvbkGD+HEGOQnjeZNu9Pei7PGp54SxCpEpSjW4csGb6YJ9LPeFYafxS25D7O8pcdEXWgkAg+0nlT3LtTNpn213GnK4D6TaFWzYfPGosL6Q==";

    console.log("datasHTML", datasHTML);

    axios.post(apiUrl, 
        {
            datas: datasHTML,
            title: "export-CEQ-data_center.pdf",
            source: 'https://' + location.host,
            assets: {              // List assets by type for rewriting html urls
                'css': {
                   'folder': 'css', // Ce sera 'build' sur le staging ou la prod 
                   'files': ['print.css'] // print.min.css staging/prod
                 }
            },
            landscape: (isMap == "") ? true : false
        },
        {
            responseType: 'blob',
            // withCredentials: true,
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + accessToken,                
            }
    }).then(response => {
        var file = new Blob([response.data], { type: 'application/pdf' })
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL); 
        var a         = document.createElement('a');
        a.href        = fileURL; 
        a.target      = '_blank';
        a.download    = 'export-CEQ-data_center.pdf';
        document.body.appendChild(a);
        a.click();
    })
}

function getCurrentDate(){
    let currentDate = new Date();
    let options = { year: 'numeric', month: 'long', day: 'numeric' };
    let dateString = currentDate.toLocaleDateString('en-US', options);

    return dateString;
}

function isTouchDevice() {
    return ('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0);
}

export {
    GLOBAL_REAL_ESTATE,
    DATASETS_PARAMS,
    INDICATORS_PARAMS,
    UNITS_PARAMS,
    DB_REGIONS,
    ALL_REGION_ID,
    DB_INCOME_LEVELS,
    ALL_INCOME_LEVEL_ID,
    DB_COUNTRIES_OBJ,
    FINANCIAL_REGIONS,
    DB_REALESTATE_CITIES,
    DB_COUNTRIES_DENOMINATOR_OBJ,
    REAL_ESTATE_TOOLTIPS,
    DB_FINANCIAL,
    loadDatasetsCSVData,
    loadEffectiveTaxModalCSVData,
    loadProfitShiftingModalCSVData,
    loadDatasetsSpreadsheetData,
    loadSingleDatasetsCSVData,
    loadSingleDatasetsSpreadsheetData,
    loadCountriesCSVData,
    loadCountriesSpreadsheetData,
    loadTextsSpreadsheetData,
    loadTextsCSVData,
    loadDownloadSpreadsheetData,
    loadDownloadCSVData,
    computeYearsMaxValue,
    computeYearMaxValue,
    formatFloatToSignificantDigits,
    formatNumber,
    loadRealEstate2SpreadsheetData,
    loadRealEstate2CSVData,
    loadStaticSpreadsheetData,
    loadStaticCSVData,
    exportGTAB,
    getCurrentDate,
    isTouchDevice
}



// WEBPACK FOOTER //
// ./commons/utils/index.js